import React from 'react';
import { Dropdown as AntDrop } from 'antd';
import { CaretRightSmall, MoreDotsHorz } from '@nackle/origami-icons';
import classNames from 'classnames';

const getSize = ( size ) => {
    if ( !size ) {
        return '';
    }
    if ( size === 'large' ) {
        return 'ant-dropdown-large';
    }
    if ( size === 'small' ) {
        return 'ant-dropdown-small';
    }
    return '';
};

const MenuRender = ( { menu, dropdownClasses } ) => {
    return (
        <div className={ dropdownClasses }>
            {
                React.cloneElement( menu )
            }
        </div>
    );
};

/**
 * A styled dropdown
 *
 * {@link https://ant.design/components/dropdown#api}
 *
 * @module Dropdown
 * @param {Object} props - the component props
 * @param {string} [props.size] - the dropdown size
 * @param {boolean} [props.arrow] - whether or not to show an arrow
 * @param {string} [props.dropdownClasses] - the css classes for the dropdown
 * @param {React.ReactNode} [props.menu] - the menu to render under dropdown
 * @param {React.ReactNode} [props.icon] - the icon to render in the dropdown
**/
const Dropdown = ( { children, ...props } ) => {
    const dropdownSize = getSize( props.size );
    const arrowClass = props.arrow ? '' : 'no-arrow';
    const dropdownClasses = classNames( {
        'ant-dropdown-content': true,
        [ dropdownSize ]: true,
        [ props.className ]: props.className ? true : false,
        [ arrowClass ]: true
    } );
    return (
        <AntDrop { ...props }
            menu={ { ...props.menu, expandIcon: <CaretRightSmall /> } }
            dropdownRender={ ( menu ) => MenuRender( { menu, dropdownClasses } ) }
        >{ children }</AntDrop>
    );
};

Dropdown.Button = ( { children, ...props } ) => {
    const { icon } = props;

    return (
        <AntDrop.Button { ...props } icon={ icon ? icon : <MoreDotsHorz /> }>{ children }</AntDrop.Button>
    );
};

export default Dropdown;
